/* global __DEV__ */

export const currentEnvironment = () =>
  process.env.APP_ENV ||
  process.env.REACT_APP_ENV ||
  process.env.NEXT_PUBLIC_ENV ||
  process.env.NODE_ENV ||
  'production';

export const isLocalRuntime = () => {
  // React Native: __DEV__ is true on debug builds, which load their bundle from Metro on a dev machine.
  if (typeof __DEV__ !== 'undefined') {
    return __DEV__;
  }

  // Two independent signals; either one means the bundle is not a deployed one:
  // - NODE_ENV is 'development' whenever a dev server (vite / craco start) serves the bundle, even
  //   when the app points at staging or production. This covers every `start:*` script on a personal laptop.
  // - The env name (currentEnvironment) is 'development' only for builds of the development env, which is never
  //   deployed. This covers production builds of it, e.g. CI e2e (`vite build` + `vite preview`),
  //   where NODE_ENV is 'production'.
  return process.env.NODE_ENV === 'development' || currentEnvironment() === 'development';
};
